export const PARTNER_ORG_LEAD_CONTACT_CHANNELS = [
  "CALL",
  "WHATSAPP",
  "EMAIL",
] as const;

export type PartnerOrganizationLeadContactChannel =
  (typeof PARTNER_ORG_LEAD_CONTACT_CHANNELS)[number];

export const PARTNER_ORG_LEAD_CONTACT_CHANNEL_OPTIONS: {
  value: PartnerOrganizationLeadContactChannel;
  label: string;
}[] = [
  { value: "CALL", label: "טלפון" },
  { value: "WHATSAPP", label: "וואטסאפ" },
  { value: "EMAIL", label: "מייל" },
];

export function isPartnerOrgLeadContactChannel(
  value: string | null | undefined,
): value is PartnerOrganizationLeadContactChannel {
  return (
    value === "CALL" || value === "WHATSAPP" || value === "EMAIL"
  );
}

export function partnerOrgLeadContactChannelLabel(
  value: string | null | undefined,
): string {
  return (
    PARTNER_ORG_LEAD_CONTACT_CHANNEL_OPTIONS.find(
      (option) => option.value === value,
    )?.label ?? ""
  );
}

export function sanitizePartnerOrgLeadContactChannel(
  channel: string | null | undefined,
): PartnerOrganizationLeadContactChannel | null {
  if (!channel || !isPartnerOrgLeadContactChannel(channel)) return null;
  return channel;
}

export function partnerOrgLeadConvertComments(
  contactChannel: string | null | undefined,
): string {
  const label = partnerOrgLeadContactChannelLabel(contactChannel);
  return label ? `דרך יצירת קשר: ${label}` : "";
}

export function partnerOrgLeadToOrganizationPrefill(lead: {
  name: string;
  handlingManagerId: string;
  contactChannel: string;
  phoneNumber?: string | null;
  email?: string | null;
  contactRole?: string | null;
}): {
  name: string;
  handlingManagerId: string;
  comments: string;
  appManagerPhone: string;
  appManagerEmail: string;
  appManagerRole: string;
} {
  return {
    name: lead.name.trim(),
    handlingManagerId: lead.handlingManagerId,
    comments: partnerOrgLeadConvertComments(lead.contactChannel),
    appManagerPhone: lead.phoneNumber?.trim() ?? "",
    appManagerEmail: lead.email?.trim() ?? "",
    appManagerRole: lead.contactRole?.trim() ?? "",
  };
}
